import {
  Directive,
  ElementRef,
  HostListener,
  Input,
  Renderer2,
} from "@angular/core";
import { Router } from "@angular/router";
import { SharedDataService, SubscriptionType } from "./shared-data.service";

@Directive({
  selector: "[chPremiumOverlay]",
  standalone: true,
})
export class PremiumOverlayDirective {
  @Input() ctaText: string;
  @Input() ctaVideo: string;

  constructor(
    private element: ElementRef,
    private renderer: Renderer2,
    private sharedDataService: SharedDataService,
    private router: Router,
  ) {}

  addOverlay() {
    const overlay = this.renderer.createElement("div");

    overlay.innerHTML = `
    <div class="premium-cta">
      <div class="premium-cta-card">
        <h4>${this.ctaText}</h4>
        <a class="btn btn-primary btn-block" href="/#/practice/practice-info">
            <i class="tio-lock_open_outlined"></i>
            Unlock Now
        </a>
      </div>
    </div>`;

    this.renderer.appendChild(this.element.nativeElement, overlay);
  }

  ngOnInit() {
    if (this.sharedDataService.subscriptionType != SubscriptionType.PREMIUM) {
      this.addOverlay();
    }
  }

  public removeOverlay() {
    const overlay = this.element.nativeElement.querySelector("div");
    this.renderer.removeChild(this.element.nativeElement, overlay);
  }
}
